<template>
  <view>
    城市：<el-input type="text" v-model="queryParams.cityName" style="width: 200px">城市名称</el-input>
    <el-button type="primary" @click="query">查询</el-button>
    <el-table :data="cityList.slice((currentPage-1)*queryParams.pageSize, currentPage*queryParams.pageSize)">
      <el-table-column label="序号" prop="id" width="100"></el-table-column>
      <el-table-column label="城市名称" prop="name"></el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total">
    </el-pagination>
  </view>
</template>

<script>
import {cityQuery} from "@/utils/area";
import {ElMessage} from "element-plus";
import {ref} from "vue";

const form = ref([]);
const cityList=ref([]);
const total=ref(0);
const currentPage=ref(1);
const pageSize=ref(10);

export default {
  name: "TestPaging",
  data: function () {
    return {
      form:form,
      queryParams:{
        pageNum:currentPage,
        pageSize:pageSize,
        cityName:"",
      },
      cityList:cityList,
      total:total,
      currentPage:currentPage
    }
  },
  created() {
    this.query();
  },
  methods:{
   async query(){
      await cityQuery(this.queryParams.pageNum,this.queryParams.pageSize,this.queryParams.cityName)
          .then(response => {if (response.code === "200") {
        cityList.value = response.data;
        console.log(cityList.value);
        total.value=cityList.value.length;
      } else {
        ElMessage.warning(response.msg);
      }});
    },
    handleSizeChange(val){
     this.queryParams.pageSize=val;
    },
    handleCurrentChange(val){
      this.currentPage = val;

    }

  }
}
</script>

<style scoped>

</style>
